import React, {useState} from 'react';
import {
    ArrowForward,
    ArrowRight,
    HeroBg,
    HeroBtnWrapper,
    HeroContainer,
    HeroContent,
    HeroH1,
    HeroP, VideoBg
} from "./HomeElements";
import Video from '../../video/video.mp4';
import {Button} from "../ButtonElement";


const HomeSection = () => {
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    }

    return (
        <HeroContainer>
            <HeroBg>
                <VideoBg autoPlay loop muted src={Video} type ='video/ mp4'></VideoBg>
            </HeroBg>
            <HeroContent>
                <HeroH1>Hi! </HeroH1>
                <HeroP>
                    I am Snedden Gonsalves , a software developer, and on a mission to finish this website within a month.Lets see if deploy works
                </HeroP>
                <HeroBtnWrapper>
                    <Button onMouseEnter = {onHover} onMouseLeave = {onHover}
                        primary='true'
                        dark='true'
                        to='contactMe'
                        smooth = 'true'
                        duration={500} spy={true}


                    >
                        Contact me {hover? <ArrowForward/> : <ArrowRight/>}
                    </Button>
                </HeroBtnWrapper>
            </HeroContent>
        </HeroContainer>
    )
}

export default HomeSection;
